<template>
  <div>
    <v-container fluid class="pt-0">
      <v-row class="topbanner-bg">
        <v-col cols="12">
          <v-row class="justify-center">
            <v-col cols="6" md="4" class="text-center">
                <v-img
                  aspect-ratio="2"
                  max-width="200"
                  src="./assets/logo_app_glow.png"
                  style="margin: 0 auto"
                />
            </v-col>
          </v-row>
          <v-row class="justify-center mt-5">
            <v-col cols="12" md="4">          
              <v-card>
                  <v-card-title>
                    <v-spacer />
                    ATTENZIONE!
                    <v-spacer />
                  </v-card-title>
                  <v-card-text class="text-center">
                    Il pagamento è stato annullato.<br>
                    Seleziona di nuovo l'abbonamento che desideri per procedere al pagamento.
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn rounded color="primary" class="px-4 mb-4" @click="$router.replace('/subscription')">
                      TORNA ALLA PAGINA DI ABBONAMENTO
                    </v-btn>
                    <v-spacer />
                  </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {

  data: () => ({
  }),

};
</script>

<style scoped>
.topbanner-bg {
  background-image: url("./assets/bg.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  min-height: 100vh;
}
</style>
